export default {
    fund: [{
            "title": "关于投资者权益保护教育的表述，以下错误的是（　　）。",
            "question": "A. 权益保护教育是公平原则在投资者教育领域中的体现\nB. 投资者权益保护教育即号召投资者为改变其投资决策的社会和市场环境进行主动参与与保护自身权益\nC. 投资者权益保护教育营造一个公正的环境，给客户提供相近的回报\nD. 权益保护教育是市场化的要求",
            "answer": "C",
            "explain": "本题考查投资者权益保护教育。A、D选项表述正确，权益保护教育不仅是市场化的要求，也是公平原则在投资者教育领域的体现。B选项表述正确，权益保护教育即号召投资者为改变其投资决策的社会和市场环境进行主动参与与保护自身权益。C选项表述错误，投资者权益保护不能给客户提供回报保证。"
        },
        {
            "title": "某基金管理公司固定收益部利用同学的名义开立证券账户，该账户由其实际操控并操作，甲看好某只股票时，其管理的基金买入，该账户也同步买入，对甲的行为，以下说法错误的是（　　）。",
            "question": "A. 甲的行为违反了忠诚尽责的基金从业人员职业道德规范\nB. 甲的行为违反了诚实守信的基金从业人员职业道德规范\nC. 甲的行为违反了守法合规的基金从业人员职业道德规范\nD. 甲的行为违反了专业审慎的基金从业人员职业道德规范",
            "answer": "B",
            "explain": "本题考查基金经理道德规范。诚实守信的要求包括不得欺诈客户，不得内幕交易和操纵市场，不得进行不正当竞争，题目中没有涉及到欺诈客户，也没有说利用内幕信息赚钱，虽然他操作了2个账户，但是他没有影响市场其他参与者的意图，只是想给自己赚点钱，所以不涉及操作市场。也没有同行业的竞争，不是不正当竞争，所以不违反诚实守信的原则。"
        },
        {
            "title": "关于基金销售业务内部控制的主要内容，以下表述错误的是（　　）。",
            "question": "A. 对签订基金代销协议的基金销售机构进行尽职调查，并监督基金代销行为符合协议约定\nB. 评估客户投诉风险，采取适当措施，及时妥善处理客户投诉\nC. 基金申购、赎回和转换申请均需经过客户的授权，并及时地执行\nD. 准确记录客户投诉的内容，为保护客户隐私，投诉电话不得录音",
            "answer": "D",
            "explain": "本题考查内部控制的内容和基金客户投诉处理的内容。A选项表述正确，内部控制的销售业务控制包含：建立代销机构的尽职调查流程，严格选择合作的基金销售机构，审核销售协议，监督基金代销行为符合协议约定。B选项表述正确，客户投诉处理的内容包含：评估客户投诉风险，采取适当措施，及时妥善处理客户投诉。C选项表述正确，申购、赎回和转换交易申请均经过客户的合理授权，并被准确、及时地执行。D选项表述错误，耐心倾听投资者的意见、建议和要求，准确记录客户投诉的内容，所有客户投诉应当保留完整记录并存档，投诉电话应当录音（而不是不得录音）。"
        },
        {
            "title": "关于基金募集失败的处理方式，以下说法正确的是（　　）。",
            "question": "A. 在募集期届满后10日内，由管理人返还投资者已缴纳的款项\nB. 仅返还投资者净认购金额\nC. 管理人、托管人、销售机构有权在募集资金中计提因募集行为而产生的费用和应得的报酬\nD. 除需要返还投资者已缴纳的投资本金外，还应加计银行同期存款利息补偿投资者",
            "answer": "D",
            "explain": "本题考查对基金募集失败的处理。基金募集失败，基金管理人应当承担下列责任：（1）以其固有财产承担因募集行为而产生的债务和费用（C项说法错误）；（2）在基金募集期限届满后30日内返还投资人已缴纳的款项（A项说法错误），并加计银行同期存款利息（B项说法错误，D项说法正确）。"
        },
        {
            "title": "关于QDII基金的信息披露，以下说法正确的是（　　）。",
            "question": "A. 可以同时采用中文和主要投资国语言披露信息，并以中文为准\nB. 可以同时采用中文和主要投资国语言披露信息，并以主要投资国语言为准\nC. 可以同时采用中文和英文披露信息，并以中文为准\nD. 可以同时采用中文和英文披露信息，并以英文为准",
            "answer": "C",
            "explain": "本题考查QDII基金的信息披露。C选项说法正确，QDII基金在披露相关信息时，可同时采用中文和英文，并以中文为准（而不是以英文为准）。"
        },
        {
            "title": "关于基金的宣传推介材料，以下不合规的是（　　）。",
            "question": "A. 客户经理制作的基金的营销卖点\nB. 银行对基金的投资风险提示\nC. 基金公司制作的基金的微信宣传推介材料\nD. 基金评级机构对基金的评级说明",
            "answer": "A",
            "explain": "本题考查基金宣传推介材料的规范。A项不符合规定，基金宣传推介材料禁止登载单位或者个人的推荐性文字，所以客户经理制作的基金的营销卖点不符合规定。"
        }, {
            "title": "以下关于基金前后端收费说法错误的是（　　）。",
            "question": "A. 后端收费是在赎回时从赎回金额中扣除\nB. 对于持有期低于3年的投资人，基金管理人可以免收其后端申购费用\nC. 前端收费是在基金份额申购时收取\nD. 基金同时设置前后端收费的，前端收费的最高档位申购费率应低于对应的后端收费的最高档申购费率",
            "answer": "B",
            "explain": "本题考查基金的前后端收费。A、C选项说法正确，前端收费在基金份额申购时收取。后端收费在赎回时从赎回金额中扣除。B选项说法错误，后端收费时基金管理人可以选择根据投资人持有期限不同分段设置申购费，对于持有期低于3年的投资人，基金管理人不得免收其后端申购费(B选项描述错误，不是“可以免收”)。D选项说法正确，基金前端收费的最高档位申购费率应低于对应的后端收费的最高档申购费率。"
        },
        {
            "title": "关于基金销售机构的准入条件，以下表述错误的是（　　）。",
            "question": "A. 基金销售机构应当财务状况良好，运作规范稳定\nB. 基金销售机构应当具有健全的治理结构，完善的内部控制和风险管理制度\nC. 基金销售机构的基金销售业务技术系统应当与证券交易所相应的技术系统进行联网测试，测试结果符合国家规定的标准\nD. 基金销售机构应当具备与基金销售业务相适应的营业场所，安全防范设施和其他设施",
            "answer": "C",
            "explain": "本题考查基金销售机构的准入条件。基金销售机构是指依法办理开放式基金份额的认购、申购和赎回的基金管理人以及取得基金代销业务资格的其他机构。A选项表述正确，基金销售机构应当财务状况良好，运作规范稳定。B选项表述正确，基金销售机构应当具有健全的治理结构，完善的内部控制和风险管理制度，并得到有效执行。C选项表述错误，基金销售机构的基金销售业务的技术系统已与基金管理人、中国证券登记结算公司(而不是选项中所说的证券交易所)相应的技术系统进行了联网测试，测试结果符合国家规定的标准。"
        },
        {
            "title": "采用封闭式运作方式的基金具有如下特征（　　）。",
            "question": "A. 在合同期限内，基金份额持有人不能申请申购，但可以赎回\nB. 在合同期限内，基金份额持有人不能申请申购，也不能赎回\nC. 基金资产总值在合同期限内固定不变\nD. 基金份额持有人不得申请赎回的一种基金运作方式",
            "answer": "D",
            "explain": "本题考查封闭式基金。A、B选项说法错误，封闭式基金份额持有人在合同期限内既不能申购也不能赎回。C选项说法错误，D选项说法正确，封闭式基金是指基金份额在基金合同期限内固定不变，基金份额可以在依法设立的证券交易所交易，但基金份额持有人不得申请赎回的一种基金运作方式。"
        },
        {
            "title": "根据《证券投资基金法》的规定，关于公开募集证券投资基金募集期届满后的法定程序，以下表述正确的是（　　）。",
            "question": "A. 基金托管人与基金管理人共同聘请验资机构进行验资后，在中国证监会办理备案\nB. 由基金管理人聘请验资机构进行验资之后，在中国证监会办理备案\nC. 基金管理人应当根据基金募集规模依法决定是否需要验资\nD. 由基金管理人报中国证监会备案之后，聘请验资机构进行验资",
            "answer": "B",
            "explain": "本题考查基金的备案。基金募集期限届满，封闭式基金募集的基金份额总额达到准予注册规模的80%以上，开放式基金募集的基金份额总额超过准予注册的最低募集份额总额，并且基金份额持有人人数符合中国证监会规定的，管理人应当自募集期限届满之日起10日内聘请法定验资机构验资，自收到验资报告之日起10日内，向证监会提交验资报告，办理基金备案手续，并予以公告。A选项表述错误，是由基金管理人聘请，而不是基金托管人和基金管理人共同聘请。"
        },
        {
            "title": "A基金管理公司决定与各类销售机构广泛合作，开展相关促销活动，在合作前，按制度对各家销售基金的销售机构的销售适用性工作和水平进行考核，以下不属于基金销售适用性管理制度的组成内容的是（　　）。",
            "question": "A. 基金投资人风险承受能力调查和评估的方式和方法\nB. 基金产品风险评价的方式和方法\nC. 基金产品和基金投资人进行匹配的方法\nD. 基金产品绩效归因的方式和方法",
            "answer": "D",
            "explain": "本题考查基金销售机构适用性的管理制度。基金销售机构适用性的管理制度包括：(1)对基金管理人进行审慎调查的方式和方法；(2)对基金产品或者服务的风险等级进行设置，对基金产品或者服务进行风险评价的方式或方法(B项符合题意)；(3)对投资者进行分类的方法与程序，投资者转化的方式和程序。"
        },
        {
            "title": "关于交易日ETF基金份额参考净值与基金份额净值，以下说法错误的是（　　）。",
            "question": "A. 基金份额净值通过证券交易所行情发布系统于次1个交易日揭示\nB. 在交易时间内，每15秒显示一次最新基金份额参考净值\nC. 基金份额净值于交易日当日在指定报刊和管理人网站披露\nD. 在交易时间内，即时揭示基金份额参考净值",
            "answer": "C",
            "explain": "本题考查ETF的信息披露。ETF是以某一选定的指数所包含的成分证券或商品为投资对象，依据构成指数的证券或商品的种类和比例，采取完全复制或抽样复制的被动型指数基金。A选项说法正确，交易日的基金份额净值通过证券交易所的行情发布系统于次1个交易日揭示。B选项说法正确，在交易时间内，ETF每15秒提供一个基金参考净值报价。C选项说法错误，交易日的基金份额净值按规定于次日(而不是当日)在指定报刊和管理人网站披露。"
        }, {
            "title": "关于资产配置教育，以下表述正确的是（　　）。",
            "questions": "I. 更关注投资者具体的投资行为<br>II. 内容是关于如何开展证券投资的<br>III. 关于如何指导投资者对个人资产进行科学的计划和控制的<br>IV. 计划会对投资决策和策略带来重大影响，因此资产配置教育应不只关注具体的投资行为",
            "question": "A. I、II、III、IV\nB. I、II、III\nC. I、II\nD. III、IV",
            "answer": "D",
            "explain": "本题考查资产配置教育。I项表述错误，IV项表述正确，许多投资者教育专家都认为投资者教育的范围应超越投资者具体的投资行为，才能从根本上解决投资者的困惑。"
        },
        {
            "title": "在完成私募基金风险揭示后，募集机构应当审查投资者是否符合私募产品合格投资者标准，如果投资者为个人，募集机构应当要求投资者提供必要的证明文件包括的（　　）。",
            "questions": "I. 收入证明文件<br>II. 金融资产证明文件<br>III. 所有资产在内的财产证明文件",
            "question": "A. I和II\nB. I或II\nC. I和II和III\nD. I或II或III",
            "answer": "B",
            "explain": "本题考查资格审查的相关内容。在完成私募基金风险揭示后，募集机构应当要求投资者提供必要的资产证明文件或收入证明。募集机构应当合理审慎地审查投资者是否符合私募基金合格投资者标准，依法履行反洗钱工作并确保单只私募基金的投资者人数累计不超过《证券投资基金法》《公司法》《合伙企业法》等法律规定的特定数量。B项符合题意。"
        },
        {
            "title": "关于基金管理人内部控制的原则，说法错误的是（　　）。",
            "question": "A. 健全性原则\nB. 成本效益原则\nC. 有效性原则\nD. 相互依赖原则",
            "answer": "D",
            "explain": "本题考查内部控制的原则。内部控制是指公司为防范和化解风险、充分考虑内外部环境、通过建立组织机制、运用管理方法、实施操作程序与控制措施而形成的系统。基金管理人内部控制的原则包括：健全性原则、有效性原则、独立性原则、相互制约原则、成本效益原则。D选项说法错误，内部控制的原则不包括相互依赖原则。"
        },
        {
            "title": "下列行为中，构成不正当竞争的是（　　）。",
            "questions": "I. 基金管理公司A为了销售基金，开展“零费率”活动，自己承担基金销售成本<br>II. 基金管理公司B开展“开户有礼”活动，在活动期间成功开立基金账户的客户可以获赠电影票<br>III. 基金管理公司C为庆祝成立1周年，邀请部分忠实客户参加纪念活动并赠送印有公司商标的小额纪念品<br>IV. 基金管理公司D为了打击竞争对手，捏造、散布对方核心投资管理人员被公安机关调查的消息",
            "question": "A. I、II、IV\nB. II、III、IV\nC. II、IV\nD. I、II、III、IV",
            "answer": "A",
            "explain": "本题考查不得进行不正当竞争的相关要求。诚实守信规范要求基金从业人员不得进行不正当竞争。"
        },
        {
            "title": "甲从某基金管理公司离职时，带走了公司的客户清单，并将这些客户招揽至新任职的基金公司，这一行为属于（　　）。",
            "question": "A. 泄露商业秘密\nB. 泄露内部信息\nC. 不公平对待客户\nD. 没有违规",
            "answer": "A",
            "explain": "本题考查保守秘密的基本要求。甲将原公司的客户清单用于新公司招揽客户的行为违背了保守秘密的要求。基金从业人员在执业活动中接触到的秘密主要包括三类：商业秘密、客户资料、内部信息。原公司的客户清单属于商业机密，即甲的行为属于泄露商业机密的行为。"
        },
        {
            "title": "基金公司“合规”中的“规”不包括（　　）。",
            "question": "A. 公司章程以及企业的各种内部规章制度\nB. 中国证券投资基金业协会和中国证券业协会等自律性组织制定的适用于全行业的规章制度\nC. 各个地区金融行业默认的道德准则\nD. 立法机关和中国证监会发布的基金法律规则",
            "answer": "C",
            "explain": "本题考查合规管理的含义。“合规”中的“规”包括立法机关和证监会发布的基本法律规则；基金业协会和证券业协会等自律性组织制定的适用于全行业的规范、标准、惯例等；公司章程以及企业的各种内部规章制度以及应当遵守的诚实、守信的职业道德。"
        }, {
            "title": "根据《证券投资基金销售适用性指导意见》的规定，基金管理人需要对基金代销机构进行审慎调查，需要了解的信息包括（　　）。",
            "question": "A. 基金代销机构的内部控制情况、管理框架体系、市场推广预算、销售人员学历、持续营销能力\nB. 基金代销机构的内部控制情况、信息管理平台建设、账户管理制度、销售人员能力、持续营销能力\nC. 账户管理制度、年度销售计划、销售人员学历、首发销售能力、持续营销能力\nD. 公司注册资本、信息管理平台建设、账户管理制度、持续营销能力、财务健康状况",
            "answer": "B",
            "explain": "本题考查基金销售渠道审慎调查。基金管理人通过对基金代销机构进行审慎调查，了解基金代销机构的内部控制情况、信息管理平台建设、账户管理制度、销售人员能力和持续营销能力，并可将调查结果作为选择代销机构的重要依据。"
        },
        {
            "title": "基金从业人员的下列行为中，符合基金职业道德规范要求的是（　　）。",
            "question": "A. 从业人员在推荐基金时没有对所推荐的基金的未来业绩作预测\nB. 从业人员甲在介绍自己所在基金管理公司的投资业绩时，只介绍表现好的基金，刻意忽略表现不好的基金\nC. 从业人员乙向客户分发自己私下制作的宣传推介材料\nD. 从业人员丙动员一名退休老工人用自己的退休金购买结构化资产管理计划劣后级份额",
            "answer": "A",
            "explain": "本题考查诚实守信的基本要求。A选项符合题意，诚实守信要求基金从业人员在推介基金时，应当客观、全面、准确，不得片面夸大过往业绩，也不得预测所推介基金的未来业绩。B选项不符合题意，诚实守信要求基金从业人员在推介基金时，应当与基金合同、招募说明书等相符，不得进行虚假或误导性陈述，或者出现重大遗漏。C选项不符合题意，基金从业人员分发的基金宣传推介材料，应为基金管理机构或基金代销机构统一制作的材料。D选项不符合题意，基金从业人员不得向风险识别能力和风险承受能力低于产品风险等级的投资者销售产品。"
        },
        {
            "title": "基金管理人制定信息系统管理制度所应遵循的原则，不包括（　　）。",
            "question": "A. 实用性原则\nB. 安全性原则\nC. 可操作性原则\nD. 成本控制原则",
            "answer": "D",
            "explain": "本题考查信息技术系统控制。基金管理人应当根据国家法律法规的要求，遵循安全性、实用性、可操作性原则，严格制定信息系统的管理制度。D选项成本控制原则不属于制定信息技术系统控制应遵循的原则。"
        },
        {
            "title": "在传统的证券投资组合中，加入另类投资产品不能达到的作用是（　　）。",
            "question": "A. 提高信息透明度\nB. 规避通胀风险\nC. 分散风险\nD. 组合多元化",
            "answer": "A",
            "explain": "本题考查另类投资基金。A选项符合题意，另类投资涵盖范围广，发展速度快，监管上不如股票、债券等传统证券那样成熟。大部分另类投资的经理人不会将另类投资产品的信息进行公开推广，投资者能够获取的与另类投资产品相关的信息有限。"
        },
        {
            "title": "A基金管理公司决定对旗下部分基金进行持续营销。该公司市场部做了一系列基金的宣传推介材料。关于市场部开展的基金宣传推荐活动，以下做法合规的是（　　）。",
            "question": "A. 将广播广告在投放后次日起的10个工作日内报当日证监局备案\nB. 针对A基金管理公司旗下的货币市场基金，宣传其风险极低，等同于储蓄品种\nC. 为了吸引年轻客户群体，市场部通过视频网站播出基金投资者教育宣传短片，并进行了6秒的风险提示\nD. 根据中国人民银行的货币政策，基于研究院的分析就货币市场基金的中短期投资业绩进行预测",
            "answer": "C",
            "explain": "本题考查基金宣传推介材料规范。A选项说法错误，基金管理人的基金宣传推介材料，应当事先经基金管理人负责基金销售业务的高级管理人员和督察长检查，出具合规意见书，并自向公众分发或者发布之日起5个工作日内报送主要经营活动所在地中国证监会派出机构备案。"
        },
        {
            "title": "关于基金与保险产品的特点，以下表述正确的是（　　）。",
            "questions": "I. 基金是一种投资工具，投资基金的目的是获得投资收益<br>II. 保险产品是一种具有保障功能的理财工具，意义在于分散或转移风险<br>III. 基金和保险产品对于不同投资人价格的计算都是一致的<br>IV. 基金和保险产品都可以随时变现",
            "question": "A. II、IV\nB. I、II\nC. I、II、IV\nD. I、II、III、IV",
            "answer": "B",
            "explain": "本题考查基金与保险产品的差异。I项说法正确，基金是一种投资工具，目的是获得收益。"
        }, {
            "title": "某公募基金的基金合同约定“本基金80%以上的基金资产投资于债券，剩余资产不参与股票交易，但可以适当参与新股发行申购”。由此判断，该基金的类别是（　　）。",
            "question": "A. 二级债基\nB. 混合基金\nC. 一级债基\nD. 纯债基金",
            "answer": "C",
            "explain": "本题考查债券基金的类型。A选项说法错误，以债券投资策略为主，同时可适当参与新股申购和股票增发、二级市场股票等权益资产投资的称为“二级债基”（可以参与股票交易）。B选项说法错误，本基金80%以上的基金资产投资于债券，可知应为债券基金，而非混合基金。C选项说法正确，以债券投资策略为主，可适当参与新股申购和股票增发等称为“一级债基”。"
        },
        {
            "title": "以下属于基金从业人员职业道德中“专业审慎”要求的是（　　）。",
            "question": "A. 保守客户秘密\nB. 不得进行内幕交易和操纵市场行为\nC. 遵守法律法规等行为规范，包括公司内部的制度规定\nD. 通过基金从业人员资格考试，持证上岗",
            "answer": "D",
            "explain": "本题考查基金职业道德规范中专业审慎的要求。专业审慎的基本要求包括：(1)持证上岗(D选项正确)；(2)持续学习；(3)审慎开展职业活动。A选项说法错误，保守客户秘密属于保守秘密的要求。"
        },
        {
            "title": "关于巨额赎回的处理，以下说法错误的是（　　）。",
            "question": "A. 基金管理人可以根据法规要求及其兑付能力而决定接受全额赎回或部分延期赎回\nB. 基金管理人认为兑付投资者的赎回申请有困难时，可以拒绝赎回\nC. 基金管理人认为兑付投资者的赎回申请有困难时，可以在当日接受赎回比例不低于上一日基金总份额10%的前提下，对其余部分延期办理\nD. 基金连续2个开放日以上发生巨额赎回，如基金管理人认为有必要，可暂停接受赎回申请",
            "answer": "B",
            "explain": "本题考查巨额赎回的处理。单个开放日基金净赎回申请超过基金总份额的10%时，为巨额赎回。A选项说法正确，出现巨额赎回时，基金管理人可以根据基金当时的资产组合状况(即兑付能力)接受全额赎回或者部分延期赎回。B选项说法错误，基金管理人认为兑付投资者的赎回申请有困难时，可延期办理，而不是拒绝赎回。"
        },
        {
            "title": "下列各类业务中，属于我国资产管理业务的有（　　）。",
            "questions": "I. 公开募集证券投资基金业务<br>II. 私募股权投资基金业务<br>III. 集合资金信托业务<br>IV. 个人理财产品业务",
            "question": "A. I、II、III\nB. I、II、III、IV\nC. I、II\nD. I、III",
            "answer": "B",
            "explain": "本题考查我国资产管理业务。我国资产管理业务主要包括：(1)基金管理公司及其子公司资产管理业务，如公开募集基金的募集和管理业务、特定客户资产管理业务(包括1项)。"
        },
        {
            "title": "托管人在（　　）情况下不需发布临时报告。",
            "question": "A. 托管人的专门基金托管部门主要业务人员在1年内变动超过20%\nB. 托管人的法定名称或者住所变更\nC. 涉及托管业务的诉讼\nD. 托管人召集基金份额持有人大会",
            "answer": "A",
            "explain": "本题考查基金托管人的信息披露义务。当基金发生涉及托管人及托管业务的重大事件时，托管人应当在事件发生之日起2日内日内编制并披露临时公告书，并报中国证监会及地方监管局备案：(1)基金托管人的专门基金托管部门的负责人变动，该部门的主要业务人员在1年内变动超过30%；(2)托管人召集基金份额持有人大会(D选项不符合题意)；(3)托管人的法定名称或住所发生变更(B选项不符合题意)。"
        },
        {
            "title": "基金销售人员需由所在机构进行执业注册登记，未经（　　）聘任，任何人员不得从事基金销售活动。",
            "question": "A. 中国证券投资基金业协会或基金公司\nB. 基金公司或销售机构\nC. 中国证监会\nD. 中国证券投资基金业协会或销售机构",
            "answer": "B",
            "explain": "本题考查对基金销售人员的资格要求。基金从业人员需由所在机构进行执业注册登记，未经基金管理人或者基金销售机构聘任，任何人员不得从事基金销售活动。A、C、D选项不符合题意，中国证监会负责政策的制定，中国证券投资基金业协会主要负责人员的自律管理，能够聘任的只有基金公司或者销售机构，中国证监会和中国证券投资基金业协会不会聘任销售人员。"
        },
        {
            "title": "根据基金管理公司治理的业务与信息隔离制度，以下做法正确的是（　　）。",
            "question": "A. 基金管理公司的股东认购了该基金管理公司的基金，作为最大的基金份额持有人，股东要求基金管理公司每月提供基金的全部投资明细\nB. 某基金管理公司股东的股票投资力量很强，为了指导基金管理公司的股票研究和投资，要求基金管理公司给股东的研究员开放投资交易系统的投资查询权限\nC. 基金管理公司股东拟对基金管理公司开展全面审计，按照公司章程的规定，先经过基金管理公司董事会批准\nD. 某基金管理公司与其股东共同开发了电子商务平台，实现客户信息共享，基金管理公司和股东销售人员都可以向全部客户推销各自的产品",
            "answer": "C",
            "explain": "本题考查公司治理相关规定。A选项做法错误，在信息传递和保密方面，股东不得直接或间接要求董事、经理层及其他员工提供基金投资、研究等方面的非公开信息和资料，故股东不得要求提供投资明细。B选项做法错误，公司董事会和经理层应当公平对待所有股东，不得接受任何股东及其实际控制人超越股东会、董事会的指示，不得偏向任何一方股东，故不得要求公司开放查询权限。"
        },
        {
            "title": "根据《公开募集证券投资基金运作管理办法》的规定，申请募集基金的拟任基金管理人，基金托管人应当具备的条件，以下说法错误的是（　　）。",
            "question": "A. 最近半年内向证监会提交的注册基金申请材料，不存在虚假记载，重大遗漏\nB. 最近一年内没有因重大违法违规行为，重大失信行为受到行政处罚\nC. 招募说明书真实准确，完整披露了投资者做出投资决策所需的重要信息，不存在虚假记载、误导性陈述或重大遗漏，语言简明易懂\nD. 不存在治理结构不健全，经营管理混乱等重大经营风险",
            "answer": "A",
            "explain": "本题考查基金募集申请。根据《公开募集证券投资基金运作管理办法》的规定，申请募集基金，拟任基金管理人、托管人应当具备以下条件：A选项说法错误，最近一年内向中国证监会提交的注册基金申请材料不存在虚假记载、误导性陈述或者重大遗漏。"
        },
        {
            "title": "某私募基金管理人，以自行销售的方式进行基金产品的募集，以下做法正确的是（　　）。",
            "question": "A. 该基金管理人内部从业人员的家属认购产品，视为合格投资人\nB. 根据优异的历史业绩，向投资者告知产品的本金将保证安全\nC. 采取当面交流的形式，由投资者口头确认产品风险揭示\nD. 私募基金可以在设置特定对象确定程序的募集机构官方网站、微信朋友圈等互联网媒介宣传推介",
            "answer": "D",
            "explain": "本题考查私募基金募集的相关内容。私募基金是指以非公开方式向投资者募集资金设立的投资基金。A选项做法错误，只有满足私募合格投资者标准的才能视为合格投资人，若从业人员家属满足合规投资者标准才能视为合格投资人。B选项做法错误，基金销售人员销售基金产品禁止违规对投资者做出盈亏承诺。C选项做法错误，基金销售人员销售基金产品禁止与投资者以口头形式确认产品风险揭示，必须采用书面形式确认投资者已知晓产品风险。"
        },
        {
            "title": "某私募基金于2017年10月27日清算终止，按《私募投资基金监督管理暂行办法》规定，该私募基金的管理人应该妥善保存该私募基金投资决策、交易和投资者适当性管理等方面的记录和其他相关资料。保存期至少应当至（　　）。",
            "question": "A. 2022年10月27日\nB. 2027年10月27日\nC. 2037年10月27日\nD. 2032年10月27日",
            "answer": "B",
            "explain": "本题考查非公开募集基金的信息保管。私募基金管理人、托管人及销售机构应当妥善保存私募基金投资决策、交易和投资者适当性管理等方面的记录及其他相关资料，保存期限自基金清算终止之日起不得少于10年。本题中该私募基金于2017年10月27日清算终止，故保存期至少应当至2027年10月27日。"
        },
        {
            "title": "根据中国证券投资基金法的规定，关于中国证监会依法履行职责有权采取的监管措施，以下说法正确的是（　　）。",
            "question": "A. 对怀疑以及或者可能转移或者隐匿违法资金、证券等涉案财产的，中国证监会办案人员可以直接予以冻结或者查封\nB. 经中国证监会主要负责人批准，办案人员可以复制基金公司的任意交易记录\nC. 中国证监会办案人员在调查与违法案件有关的资金账户，证券账户和银行账户时，必须获得公安机关的协助\nD. 在调查操纵证券市场、内幕交易等重大证券违法行为时，经中国证监会主要负责人批准，可以限制被调查事件当事人的证券买卖",
            "answer": "D",
            "explain": "本题考查中国证监会对基金市场的监管措施。A选项说法错误，对有证据证明已经或可能转移或者隐匿违法资金、证券等涉案财产或者隐匿、伪造、损毁重要证据的，经中国证监会主要负责人批准（需经批准，而不是直接冻结或者查封），可以冻结或者查封。"
        },
        {
            "title": "当基金投资者与基金从业人员，基金从业人员所在机构及其股东等利益发生冲突时，应优先保护（　　）的利益。",
            "question": "A. 基金从业人员\nB. 基金投资者\nC. 基金从业人员所在机构\nD. 基金从业人员所在机构的股东",
            "answer": "B",
            "explain": "本题考查基金份额持有人利益优先原则。基金份额持有人利益优先原则是指基金管理公司从公司章程、规章制度、工作流程、议事规则等的制定到公司各"
        }, {
            "title": "基金业协会说法正确的是（　　）。",
            "question": "A. 基金业协会的权力机构为理事会\nB. 基金服务机构加入协会的应当成为普通会员\nC. 公募基金管理人应当成为普通会员\nD. 分为境外会员和境内会员",
            "answer": "C",
            "explain": "本题考查基金业协会。基金业协会是证券投资基金行业的自律性组织，是社会团体法人。A选项说法错误，基金业协会的权力机构为全体会员组成的会员大会。B选项说法错误，基金服务机构加入协会的，为联席会员。"
        },
        {
            "title": "当货币市场基金正偏离度绝对值达到0.50%时，基金管理人应当暂停接受申购并在5个交易日内将正偏离度绝对值降到（　　）以内。",
            "question": "A. 0.4%\nB. 0.5%\nC. 0.2%",
            "answer": "B",
            "explain": "本题考查货币市场基金偏离度公告的类型。当正偏离度绝对值达到0.5%时，基金管理人应当暂停接受申购并在5个交易日内将正偏离度绝对值调整到0.5%以内(B选项符合题意)。"
        },
        {
            "title": "关于以摊余成本法估值的货币基金净值偏离度的信息披露，以下表述错误的是（　　）。",
            "question": "A. 在季度报告中的投资组合报告中，基金管理人将披露报告期内偏离度的绝对值在0.25%-0.5%间的次数\nB. 当偏离度的绝对值达到或者超过0.5%，基金管理人将在事件发生之日起2日内就此事项进行临时公告\nC. 在季度报告中的投资组合报告中，基金管理人在披露报告期内偏离度的最高值和最低值，偏离度绝对值的简单平均值\nD. 在中期报告和年度报告中，基金管理人将披露报告期内偏离度的绝对值达到或者超过0.25%的信息",
            "answer": "D",
            "explain": "本题考查货币市场基金偏离度公告相关内容。D项说法错误，在半年度报告和年度报告的重大事件揭示中，基金管理人将披露报告期内偏离度的绝对值达到或超过0.5%的信息。"
        },
        {
            "title": "基金评价机构对证券投资基金进行评价并通过公开形式发布评价结果的，应符合的条件包括（　　）。",
            "questions": "I. 成为中国证券业协会的普通会员<br>II. 拥有相关的基金从业人员并有一定的研究经历<br>III. 具有基金数据对接及科学的评价体系<br>IV. 具有基金评价相应的内控机制",
            "question": "A. I、II、III\nB. I、III、IV\nC. I、II、IV\nD. II、III、IV",
            "answer": "D",
            "explain": "本题考查证券投资基金分类的实践。"
        },
        {
            "title": "关于基金中基金(FOF)，以下表述错误的包括（　　）。",
            "questions": "I. 将80%以上的基金资产投资于经中国证监会依法核准或注册的公开募集的基金份额定义为FOF<br>II. 除ETF联接基金外，FOF投资其他基金时，被投资基金的运作期限不少于6个月<br>III. 除ETF联接基金外，同一管理人管理的全部FOF持有单只基金不得超过投资基金净资产的25%<br>IV. 基金管理人应当在FOF所投资基金披露净值的次日及时披露FOF份额净值和份额累计净值",
            "question": "A. II、III\nB. II、III、IV\nC. I、II、III\nD. II、IV",
            "answer": "A",
            "explain": "本题考查基金中基金的运作规范。"
        },
        {
            "title": "关于授权机制说法错误的是（　　）。",
            "question": "A. 建立健全公司授权标准和程序，确保授权制度的贯彻执行\nB. 公司员工应当在授权范围内行使职责，管理层因责任重大可在特定情况下突破授权范围\nC. 授权要适当，对已获授权的部门和人员应建立有效的评价和反馈机制，对已不适用的授权应及时修改或者取消授权\nD. 重大业务授权应当明确授权内容和时效",
            "answer": "B",
            "explain": "本题考查控制活动。A选项说法正确，股东会、董事会、监事会和管理层应当充分了解和履行各自的职权，建立健全公司授权标准和程序，确保授权制度的贯彻执行。B选项说法错误，公司各业务部门、分支机构和公司员工应当在规定授权范围内行使相应的职责，管理层不得突破授权范围。"
        }, {
            "title": "下列关于基金管理公司信息技术系统的论述中，正确的是（　　）。",
            "question": "A. 信息技术系统设计、软件开发等技术人员不得介入实际的业务操作\nB. 信息技术系统投入运行前，应当经过信息技术部门验收\nC. 基金管理人的重要电子信息数据应当在本地备份，并且长期保存\nD. 用户使用的密码口令要保持长期不变，不得向他人透露",
            "answer": "A",
            "explain": "本题考查信息技术系统控制的要求。A选项表述正确，在软件、硬件使用方面，信息技术系统设计、软件开发等技术人员不得介入实际的业务操作。B选项表述错误，在设计开发方面，信息技术系统投入运行前，应当经过业务、运营、监察稽核等部门的联合验收（并非仅经过信息技术部门验收）。C选项表述错误，在信息数据管理方面，基金管理人应建立电子信息数据的时保存和备份制度，重要数据应当异地（并非本地）备份并长期保存。"
        },
        {
            "title": "对于基金合同生效10年以上的基金，宣传推介材料应符合以下要求（　　）。",
            "question": "A. 应当登载最近2个完整会计年度的业绩\nB. 应当登载最近10个完整会计年度的业绩\nC. 应当登载最近5个完整会计年度的业绩\nD. 应当登载最近1个完整会计年度的业绩",
            "answer": "B",
            "explain": "本题考查基金宣传推介材料业绩登载规范。基金宣传推介材料是指为推介基金向公众分发或发布，使公众可以普遍获得的书面、电子或其他介质的信息。基金宣传推介材料登载过往业绩，对于基金合同生效10年以上的，应当登载最近10个完整会计年度的业绩（B选项符合题意）。"
        },
        {
            "title": "以下不属于中国证券投资基金业协会自律管理的是（　　）。",
            "question": "A. 对基金从业人员的资质进行管理\nB. 办理私募基金管理人的登记和私募基金的备案\nC. 制定《私募投资基金管理人内部控制指引》\nD. 对违规的会员进行行政处罚",
            "answer": "D",
            "explain": "本题考查基金业协会的职责。A选项属于基金业协会自律管理，基金业协会应制定行业执业标准和业务规范，组织基金从业人员的从业考试、资质管理和业务培训。B选项属于基金业协会自律管理，基金业协会应依法办理非公开募集基金的登记、备案。C选项属于基金业协会自律管理，基金业协会应制定和实施行业自律规则。"
        },
        {
            "title": "关于基金的会计核算工作，以下表述错误的是（　　）。",
            "question": "A. 基金管理人对所管理的基金应当以委托人为会计核算主体\nB. 不同基金的名册登记应当独立\nC. 不同基金账簿记录应当相互独立\nD. 对所管理的基金应当独立核算",
            "answer": "A",
            "explain": "本题考查会计系统控制。A选项表述错误，B、C选项表述正确，会计系统控制要求公司应当明确职责划分，在岗位分工的基础上明确各会计岗位职责，严禁需要相互监督的岗位由一人单独操作全过程。公司对所管理的资金应当以基金为会计核算主体（A选项，不是以委托人为会计核算主体），独立建账，独立核算，保证不同基金之间在名册登记、账户设置、资金划拨、账簿记录等方面相互独立（B、C选项）。"
        },
        {
            "title": "某私募基金于2017年10月27日清算终止，按《私募投资基金监督管理暂行办法》规定，该私募基金的管理人应该妥善保存该私募基金投资决策、交易和投资者适当性管理等方面的记录和其他相关资料。保存期至少应当至（　　）。",
            "question": "A. 2022年10月27日\nB. 2027年10月27日\nC. 2037年10月27日\nD. 2032年10月27日",
            "answer": "B",
            "explain": "本题考查非公开募集基金的信息保管。私募基金管理人、托管人及销售机构应当妥善保存私募基金投资决策、交易和投资者适当性管理等方面的记录及其他相关资料，保存期限自基金清算终止之日起不得少于10年。本题中该私募基金于2017年10月27日清算终止，故保存期至少应当至2027年10月27日。"
        }, {
            "title": "确认基金份额持有人持有基金份额的机构是（　　）。",
            "question": "A. 基金销售机构\nB. 基金托管人\nC. 基金注册登记机构\nD. 中国基金业协会",
            "answer": "C",
            "explain": "本题考查开放式基金份额登记的概念。A选项错误，基金销售机构是指依法办理开放式基金份额的认购、申购和赎回的基金管理人以及取得基金代销业务资格的其他机构。B选项错误，基金托管人是指独立于管理人的保管基金资产的依法设立并取得基金托管资格的商业银行或其他金融机构。"
        },
        {
            "title": "关于基金职业道德修养，以下说法错误的是（　　）。",
            "question": "A. 社会的培养和规格的教育有助于从业人员的职业道德修养的提高\nB. 基金职业道德修养是一种自律行为\nC. 基金职业道德修养的提高只能依靠自己的主观努力\nD. 基金职业道德修养培养关键在于“自我”的意愿和努力",
            "answer": "C",
            "explain": "本题考查基金职业道德修养。A选项说法正确，内在的学习需求与外在的教育灌输相结合，有利于基金从业人员更快速、更准确地把握和领悟基金职业道德规范的精神实质，可以起到事半功倍的效果。B、D选项说法正确，基金职业道德修养是指基金从业人员通过主动自觉的自我学习、自我改造、自我完善，将基金职业道德外在的职业行为规范内化为内在的职业道德情感、认知和信念，使自己形成良好的职业道德品质和达到一定的职业道德境界。因此是一种自律行为。"
        },
        {
            "title": "某基金公司在对研究员的绩效考核时，将基金经理对研究员研究能力的评分作为（　　）。",
            "question": "A. 建立科学的投资管理业绩评价体系\nB. 建立研究与投资的业务交流制度\nC. 建立严密的研究工作业务流程\nD. 建立研究报告质量评价体系",
            "answer": "D",
            "explain": "本题考查研究业务控制的主要内容。基金公司在对研究员的绩效考核时，可将基金经理对研究员研究能力的评分作为建立研究报告质量评价体系(D选项符合题意)。"
        },
        {
            "title": "在对自然人合格投资者的认定中，其持有金融资产规模是重要的参考因素，自然人可提供的金融资产证明材料包括（　　）。",
            "questions": "I. 不动产授权书<br>II. 银行存款证明<br>III. 股票证明<br>IV. 基金份额证明",
            "question": "A. I、III、IV\nB. I、II、III\nC. II、III、IV\nD. I、II、IV",
            "answer": "C",
            "explain": "本题考查合格投资者。合格投资者是指具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元且符合下列相关标准的个人：金融资产不低于300万元或者最近三年个人年均收入不低于50万元的个人。"
        },
        {
            "title": "XX基金公司发行XX价值精选基金(LOF)，在A银行、B银行、C证券公司和D证券公司四家销售机构和该基金公司互联网直销平台销售，以下表述正确的是（　　）。",
            "question": "A. 银行的客户不能通过B银行认购该基金\nB. 客户通过B银行认购的该基金份额可以直接在交易所卖出\nC. 银行渠道的客户不能通过证券公司渠道认购该基金\nD. 客户可以在该基金公司直销平台认购该基金，也可以在这四家销售机构认购该基金",
            "answer": "D",
            "explain": "本题考查基金的直销和代销。客户可以在该基金的直销平台购买，也可以在销售机构购买即四家销售机构进行购买。"
        },
        {
            "title": "基金销售合规性风险管理的主要措施包括（　　）。",
            "questions": "I. 对宣传推介材料，进行合规审查<br>II. 严格选择合作的销售机构<br>III. 制定符合投资者适当性法规要求的政策措施<br>IV. 制定适当的销售政策和监督措施",
            "question": "A. I\nB. I、II、III\nC. I、II、III、IV\nD. I、II",
            "answer": "C",
            "explain": "本题考查销售合规性风险。销售合规性风险管理主要措施包括：(1)对宣传推介材料进行合规审核(I项符合题意); (2)对销售协议的签订进行合规审核，对销售机构签约前进行审慎调查，严格选择合作的基金销售机构(II项符合题意);"
        }, {
            "title": "某公募基金管理人在2018年3月1日收到基金准予注册的文件，那么该基金最迟开始募集的日期应为（　　）。",
            "question": "A. 2019年2月28日\nB. 2018年5月31日\nC. 2018年8月31日\nD. 2018年3月31日",
            "answer": "C",
            "explain": "本题考查基金的募集期限基金管理人应当自收到准予注册文件之日起6个月内进行基金募集。2018年3月1日6个月后是2018年8月31日。"
        },
        {
            "title": "内部控制大纲是对公司章程规定的内控原则的细化和展开，是各项基本管理制度的纲要和总揽，内部控制大纲应当明确（　　）。",
            "questions": "I. 内控目标<br>II. 内控原则<br>III. 内控措施<br>IV. 控制环境",
            "question": "A. I、II\nB. I、II、III、IV\nC. I\nD. I、II、III",
            "answer": "B",
            "explain": "本题考查内部控制大纲的内容。"
        },
        {
            "title": "2016年7月18日，投资者赎回基金份额1000份，持有时间为5个月，赎回当日基金份额净值为1.00元，则其赎回手续费和可得到的赎回金额分别为（　　）。",
            "question": "A. 49.75元和9950.25元\nB. 50元和9950元\nC. 54.73元和10945.27元\nD. 55元和10945元",
            "answer": "B",
            "explain": "本题考查赎回费和净赎回金额的计算。目前对于不收取销售服务费的(一般为A类份额)一般股票型和混合型基金赎回费归基金财产的比例有以下规定：对持续持有期少于7日的投资人收取不低于1.5%的赎回费，对持续持有期少于30日的投资人收取不低于0.75%的赎回费，并将上述赎回费全额计入基金财产。"
        },
        {
            "title": "商业银行担任基金托管人，由（　　）审核。",
            "question": "A. 中国银保监会会同中国证券业协会\nB. 中国人民银行会同中国银保监会\nC. 中国证券投资基金业协会会同中国证监会\nD. 中国证监会会同中国银保监会",
            "answer": "D",
            "explain": "本题考查基金托管人资格的审核。商业银行担任基金托管人的，由中国证监会会同中国银保监会核准；其他金融机构担任基金托管人的，由中国证监会核准。"
        },
        {
            "title": "《证券投资基金销售管理办法》的规定，以下属于基金宣传推介材料的是（　　）。",
            "questions": "I. 基金宣传单<br>II. 基金户外广告<br>III. 公共网站链接基金广告<br>IV. 基金推介的信函",
            "question": "A. I、II、III、IV\nB. I、II、IV\nC. I、II、III\nD. I、III、IV",
            "answer": "A",
            "explain": "本题考查宣传推介材料的范围。基金宣传推介材料，是指为推介基金向公众分发或者发布，使公众可以普遍获得的书面、电子或者其他介质的信息。基金宣传推介材料主要包括：(1)公开出版资料；"
        },
        {
            "title": "某投资人认购新发行的股票型基金，选择后端收费方式缴纳认购费，其持有期限至少超过（　　）年，则基金管理人可免收其后端认购费用。",
            "question": "A. 3\nB. 1\nC. 5\nD. 2",
            "answer": "A",
            "explain": "本题考查开放式基金的认购费率和收费模式。后端收费方式下，基金管理人可以选择根据投资人持有期限不同分段设置申购费（认购费），对于持有期低于3年的投资人，基金管理人不得免收其后端申购费（认购费）。"
        }, {
            "title": "关于债券型基金与债券的区别，以下说法错误的是（　　）。",
            "question": "A. 债券型基金一般收益不固定，债券一般收益固定\nB. 债券型基金的风险一般与期限无关，债券的风险一般随到期日临近所承担的利率风险会下降\nC. 债券型基金投资于多只债券，比债券的信用风险高\nD. 债券型基金一般没有确定的到期日，债券一般有确定的到期日",
            "answer": "C",
            "explain": "本题考查债券基金与债券的区别。C项说法错误，债券基金通过分散投资可以有效避免单一债券可能面临的较高的信用风险。"
        },
        {
            "title": "若基金管理人发生重大的合规问题，公司管理层必须立即向（　　）进行汇报。",
            "question": "A. 董事会\nB. 监事会\nC. 董事长\nD. 股东会",
            "answer": "A",
            "explain": "本题考查合规管理的主要内容。基金管理人的高级管理层负责制定书面的合规政策，并根据合规风险管理状况以及法律、规则和准则的变化情况适时修订合规政策，按经董事会审议批准后传达给全体员工定期评价各项合规政策和执行状况；若发现重大的合规问题，管理层必须立即向董事会汇报。"
        },
        {
            "title": "关于基金招募说明书中的风险提示，以下表述错误的是（　　）。",
            "question": "A. 可以在招募说明书最后的页脚不显著位置，做出“不保证基金一定盈利”的表述\nB. 应该在招募说明书的正文，就基金投资于融资融券的风险因素进行分析\nC. 可以在招募说明书的显著位置，做出“基金过往业绩不预示未来表现”的表述\nD. 应该在招募说明书的正文，列明与特定基金品种相关的特定风险",
            "answer": "A",
            "explain": "本题考查基金风险提示。A选项表述错误，在招募说明书封面的显著位置，管理人一般会做出“基金过往业绩不预示未来表现；不保证基金一定盈利，也不保证最低收益”等风险提示。B、D选项表述正确。在招募说明书正文，管理人还会就基金产品的各项风险因素进行分析，并列明与特定基金品种、特定投资方法或特定投资对象相关的特定风险。"
        },
        {
            "title": "维护基金份额持有人名册的目的是确认（　　）持有基金份额的事实行为。",
            "question": "A. 基金托管银行\nB. 基金份额持有人\nC. 基金销售机构\nD. 基金注册登记机构",
            "answer": "B",
            "explain": "本题考查开放式基金份额登记概述。开放式基金份额的登记是指基金注册登记机构通过设立和维护基金份额持有人名册，确认基金份额持有人持有基金份额的事实行为。"
        },
        {
            "title": "某封闭式基金2019年7月8日的基金份额净值为1.200元，投资者当天在二级市场的卖出价格为每份1.500元，则该投资者的交易情况为（　　）。",
            "question": "A. 溢价交易，溢价率为25%\nB. 折价交易，折价率为25%\nC. 溢价交易，溢价率为20%\nD. 无折溢价",
            "answer": "A",
            "explain": "本题考查折（溢）价率。当基金二级市场价格高于基金份额净值时，为溢价交易，对应的是溢价率；当基金二级市场价格低于基金份额净值时，为折价交易，对应的是折价率。题目中份额净值为1.2元，二级市场价格为1.5元，二级市场价格高于基金份额净值，因此属于溢价交易。折（溢）价率=（1.5-1.2）/1.2=25%"
        },
        {
            "title": "按面值计价的货币市场基金每日分配收益，份额净值保持（　　）不变。",
            "question": "A. 100元\nB. 0.1元\nC. 1元\nD. 0.01元",
            "answer": "C",
            "explain": "本题考查货币市场基金净值。货币市场基金申购和赎回基金份额价格以1元人民币为基准进行计算。"
        }, {
            "title": "以下私募基金的募集行为，错误的是（　　）。",
            "question": "A. 自行销售的，不得公开推介；委托销售机构销售的，销售机构也不得公开推介\nB. 应当采用问卷调查等方式对投资者风险识别能力和风险承受能力进行评估，确认是否为合格投资人\nC. 可以自行销售，也可以委托销售机构销售私募基金\nD. 可以向投资人承诺保本，但不得向投资人承诺最低收益",
            "answer": "D",
            "explain": "本题考查对私募基金募集行为的监管。A选项行为正确，私募基金是指以非公开方式向投资者募集资金设立的投资基金，故任何机构都不得公开推介私募基金。B选项行为正确，私募基金管理人自行销售私募基金的，应当采取问卷调查等形式，对投资者的风险识别能力和风险承担能力进行评估，确认是否为合格投资人。"
        },
        {
            "title": "以下属于基金托管人职责的是（　　）。",
            "questions": "I. 基金资产保管<br>II. 基金估值及相关信息披露<br>III. 对基金投资运作进行监督<br>IV. 基金资金清算",
            "question": "A. I、III\nB. I、II\nC. I、II、III、IV\nD. I、III、IV",
            "answer": "D",
            "explain": "本题考查基金托管人的职责。《证券投资基金法》规定，基金资产必须由独立于管理人的托管人保管(D选项符合题意)，基金托管人负责基金资产保管、基金资金清算、会计复核。"
        },
        {
            "title": "关于封闭式基金的认购，以下表述正确的有（　　）。",
            "questions": "I. 认购申请一经确认就不能撤销<br>II. 投资者必须开立沪、深证券账户或沪、深基金账户及资金账户<br>III. 投资者应根据自己计划的认购量在资金账户中存入足够的资金<br>IV. 投资者以“金额”为单位提交认购申请",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、III、IV\nD. I、II、III、IV",
            "answer": "B",
            "explain": "本题考查封闭式基金的认购。I项正确，认购申请一经受理就不能撤单。(确认了就更不能撤销了)"
        },
        {
            "title": "当发生对基金份额持有人权益或者基金价格产生重大影响的事件时，基金管理人应在（　　）日内编制并披露临时报告书，并向中国证监会及地方监管局备案。",
            "question": "A. 1\nB. 2\nC. 5\nD. 1",
            "answer": "B",
            "explain": "本题考查基金临时信息披露相关内容。当发生对基金份额持有人权益或者基金价格产生重大影响的事件时，应在2日内(B选项符合题意)编制并披露临时报告书，并分别向中国证监会及地方监管局备案。"
        },
        {
            "title": "基金管理公司设立基金产品时，以下会计行为正确的是（　　）。",
            "question": "A. 将基金资产计入公司净资产\nB. 建立复核制度，防止会计差错产生\nC. 为提高基金估值效率，对产品投资标的统一采用成本法估值\nD. 将同类型产品合并记账，提高记账效率",
            "answer": "B",
            "explain": "本题考查会计系统控制。A选项错误，基金资产应当独立于公司资产，独立核算，而不是计入公司净资产。B选项正确，基金管理人应当建立复核制度，通过会计复核和业务复核防止会计差错的产生。C选项错误，基金管理人应当采取合理的估值方法和科学的估值程序，公允反映基金所投资的有价证券在估值时点的价值，而不是统一采用成本法估值。D选项行为错误，公司对所管理的资金应当独立建账、独立核算，而不是合并记账。"
        },
        {
            "title": "关于开放式基金收取的申购费，以下表述正确的是（　　）。",
            "question": "A. 后端收费方式下，对于持有期为2年的投资人，管理人可以免收其后端申购费\nB. 前端收费方式下，销售机构可以对申购费实行一定的费率优惠\nC. 前端收费方式下，管理人可以按照投资人持有期限不同分段设置申购费率\nD. 后端收费方式下，管理人可以按照投资人申购金额不同分段设置申购费率",
            "answer": "B",
            "explain": "本题考查基金的申购费。投资者在办理开放式基金中购时，一般需要缴纳申购费，和认购费一样，申购费可以采用在基金份额中购时收取的前端收费方式，也可以采用在赎回时从赎回金额中扣除的后端收费方式。前端收费方式下，基金管理人可以选择根据投资人持有期限不同分段设置申购费率(C选项错误)。后端收费方式下，基金管理人可以选择根据投资人持有期限不同分段设置申购费(D选项错误)。对于持有期低于3年的投资人，基金管理人不得免收其后端申购费(A选项错误)。"
        }, {
            "title": "有关基金客户服务宣传与推介的具体工作内容，以下做法错误的是（　　）。",
            "question": "A. 在宣传与推介过程中综合运用手册、电视及广播等宣传手段\nB. 对以往销售的历史数据进行收集、评价、总结\nC. 及时准确地为投资人办理各类基金销售业务手续，识别客户有效身份\nD. 规范基金销售人员的行为，合理预测所推介基金的未来业绩",
            "answer": "D",
            "explain": "本题考查基金客户服务内容和规范。规范基金销售人员行为，产品推介时遵循如下注意事项：对基金产品的陈述、介绍和宣传，应当与基金合同、招募说明书等相符，不得进行虚假或误导性陈述，或出现重大遗漏。"
        },
        {
            "title": "为避免造成不公平对待投资者的情况，某基金销售机构对所有投资者履行相同的适当性义务，该销售机构违反了基金销售适用性的哪一条指导原则（　　）。",
            "question": "A. 及时性原则\nB. 全面性原则\nC. 投资人利益优先选择\nD. 差异性原则",
            "answer": "D",
            "explain": "本题考查基金销售机构实施基金销售适用性的指导原则。"
        },
        {
            "title": "公司内部控制大纲是对公司章程规定的内控原则的细化和展开，是各项基本管理制度的纲要和总揽。内部控制大纲应当明确（　　）。",
            "questions": "I. 内控目标<br>II. 内控原则<br>III. 内控措施<br>IV. 控制环境",
            "question": "A. I、II、III\nB. I、II\nC. I\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查内部控制大纲。公司内部控制大纲是对公司章程规定的内控原则的细化和展开，是各项基本管理制度的纲要和总揽，内部控制大纲应当明确内控目标、内控原则、控制环境、内控措施等内容。"
        },
        {
            "title": "关于基金与债券的特点，以下表述错误的是（　　）。",
            "question": "A. 债券反映的是一种债权债务关系，是一种债权凭证\nB. 债券可以给投资者带来较为确定的利息收入\nC. 基金反映的是一种信托关系，是一种受益凭证\nD. 基金是一种直接投资工具，筹集的资金主要投向实业领域",
            "answer": "D",
            "explain": "本题考查基金与债券的差异。基金反映的是一种信托关系，是一种受益权凭证；债券反映的是一种债权债务关系，是一种债权凭证。"
        },
        {
            "title": "在基金定期公告中，基金管理人需要编制当期季度报告、中期报告和年度报告。只有在基金合同生效不足（　　）个月的情况下，才可以不编制。",
            "question": "A. 5\nB. 3\nC. 2\nD. 4",
            "answer": "C",
            "explain": "本题考查基金管理人的信息披露义务。对于当期基金合同生效不足2个月的基金，可以不编制当期季度报告、中期报告和年度报告。"
        },
        {
            "title": "下列基金收费项目中，属于一次性计提的费用是（　　）。",
            "questions": "I. 申购费<br>II. 赎回费<br>III. 销售服务费<br>IV. 管理费\nV. 托管费",
            "question": "A. I、II、III、IV\nB. I、II、III\nC. I、II\nD. II、III、IV",
            "answer": "C",
            "explain": "本题考查基金的费用。在讲到基金的费用的时候，说到基金的管理费、托管费、销售服务费是属于按日计提，按月支付的费用，所以正确的应该选择C选项。"
        }, {
            "title": "社会道德规范是一个国家所有公民应当遵守的道德规范的总和，道德是一种社会形态，以下不属于道德特征的是（　　）。",
            "question": "A. 具有具体性\nB. 具有差异性\nC. 具有继承性\nD. 具有强制性",
            "answer": "D",
            "explain": "本题考查道德的特征。道德的特征：（1）道德具有差异性（2）道德具有继承性（3）道德具有约束性（4）道德具有具体性D项强制性不属于道德的特征。"
        },
        {
            "title": "基金监管的首要目标是（　　）。",
            "question": "A. 规范证券投资活动\nB. 保护投资人合法权益\nC. 促进证券投资基金发展\nD. 促进资本市场发展",
            "answer": "B",
            "explain": "本题考查基金监管目标。B选项符合题意，依法保护投资人及相关当事人的合法权益，是基金监管的首要目标。"
        },
        {
            "title": "关于基金监督机构和自律组织，以下表述错误的是（　　）。",
            "question": "A. 中国证监会监督管理的对象包括基金管理人、基金托管人等\nB. 在我国，证券交易所是基金的自律管理机构之一\nC. 在交易所上市的封闭式基金、上市开放式基金需要通过证券交易所来进行募集和交易\nD. 在我国，中国证券投资基金业协会是基金行业自律组织之一",
            "answer": "C",
            "explain": "本题考查基金监管机构和自律组织。C项说法错误，证券交易所为证券集中交易提供场所和设施，不负责基金的募集。"
        },
        {
            "title": "张某拟投资上市开放式基金(LOF),关于其可以采取的交易方式,以下说法正确的包括（　　）。",
            "questions": "I. 在代销该基金的银行中购该基金<br>II. 在证券交易所买进该基金,并只能在证券交易所卖出<br>III. 在银行中购该基金转托管到证券交易所卖出<br>IV. 在银行申购的基金份额只能在银行赎回",
            "question": "A. II、III\nB. I、IV\nC. I、III\nD. III、IV",
            "answer": "B",
            "explain": "本题考查LOF份额的申购和赎回。I项说法正确，投资者可通过基金管理人及其代销机构在场外办理LOF的申购和赎回。"
        },
        {
            "title": "与道德相比，法律的调整范围是（　　）。",
            "question": "A. 个人信仰\nB. 行为结果\nC. 心理动机\nD. 个人精神世界",
            "answer": "B",
            "explain": "本题考查道德与法律的区别。一般认为，道德调整的范围比法律的范围更为广泛，法律调整的对象侧重于人们的外在行为和结果的合法化，具有较强的客观性，人们的思想和动机不是法律调整的对象；而道德不仅要调整人们的外在行为和结果，还要调整人们内在的精神世界和心理动机。"
        },
        {
            "title": "根据证券交易所的上市和交易规则，关于ETF份额的上市交易，下列说法错误的是（　　）。",
            "question": "A. 实行价格涨跌幅限制，自上市首日起实行\nB. 申购时间代理券商在每一交易日开市前向证券交易所提供当日的申购，赎回清单\nC. 上市首日的开盘参考价为前一工作日基金份额净值\nD. 份额的参考净值是由证券交易所发布的",
            "answer": "B",
            "explain": "本题考查ETF的上市交易、申购和赎回。B选项说法错误，ETF上市交易后，由基金管理人在每一交易日开市前向证券交易所提供当日的申购，赎回清单，而不是由申购赎回代理券商提供。"
        }, {
            "title": "关于招募说明书，以下说法错误的是（　　）。",
            "question": "A. 招募说明书是指导投资者认购基金份额的规范性文件\nB. 招募说明书中包含基金募集申请的核准文件名称和核准日期\nC. 招募说明书中包含基金合同和基金托管协议的内容摘要\nD. 招募说明书应当披露支付给基金销售机构的客户维护费计提标准",
            "answer": "D",
            "explain": "本题考查基金招募说明书。基金管理人应当在基金半年度报告和基金年度报告（而非招募说明书）中披露从基金财产中计提的管理费、托管费、基金销售服务费的金额，并说明管理费中支付给基金销售机构的客户维护费总额。A、B、C项表述正确。"
        },
        {
            "title": "第XX届新财富最佳分析师候选人马某，在临近新财富评选前，邀请具有投票资格的相关人员聚餐，并支付聚餐费用。对此，监管机构对其采取了监管措施，其原因是（　　）。",
            "question": "A. 构成向其他利益关系人输送不正当利益的事实\nB. 以不正当方式影响监督管理或者自律管理决定\nC. 直接、间接或者险使、协助他人向监管人员输送利益\nD. 直接或者间接通过聘请第三方机构或者个人的方式输送利益",
            "answer": "A",
            "explain": "本题考查基金职业道德规范。做此类题目一定要从题干出发。题干表述马某（并非他人或第三方机构）在向相关人员（利益关系人）输送不正当的利益，最终可能影响的是评选结果（也不是在影响监督管理或者自律管理决定），与B、C、D选项无关。"
        },
        {
            "title": "基金招募说明书中的重要信息不包括（　　）。",
            "question": "A. 基金风险揭示\nB. 基金托管协议摘要\nC. 基金运作方式\nD. 基金销售协议摘要",
            "answer": "D",
            "explain": "本题考查招募说明书。招募说明书的主要披露事项包括：(1)招募说明书摘要；(2)基金资产的估值；(3)管理人和托管人的基本情况，及管理人和托管人的报酬（B选项属于披露事项）；(4)基金份额的发售日期、价格、费用和期限。"
        },
        {
            "title": "关于基金销售的后端收费模式，下列描述错误的是（　　）。",
            "question": "A. 基金管理人可以根据客户申购金额的数量适用不同的后端申购费率标准\nB. 后端收费方式是指在赎回时从赎回金额中扣除认购费或申购手续费的方式\nC. 基金管理人可以根据客户持有期限选用不同的后端申购费率标准\nD. 对于持有期低于3年的投资人，基金管理人不得免收其后端申购费用",
            "answer": "A",
            "explain": "本题考查基金的申购。A选项表述错误，基金管理人可以对选择前端收费方式的投资人根据其申购金额的数量适用不同的前端申购费率标准。B选项表述正确，后端收费是指在认购基金份额时不收费，在赎回基金份额时才支付认购费用的收费模式。C选项表述正确，基金管理人可以对选择后端收费方式的投资人根据其持有期限适用不同的后端申购费率标准。"
        },
        {
            "title": "某银行网点宣传该行T+0产品“XX宝”对接某只货币市场基金，以下做法合规的是（　　）。",
            "question": "A. 向客户宣传该行最新的保本理财产品“XX宝”销售火爆，资金使用方便灵活\nB. 向在该行办理存款的客户宣传“XX宝”和定期存款一样，且收益有时更好，是定期存款的替代品\nC. 向客户推介“XX宝”灵活便捷，并说明由于对接货币市场基金，可能由于垫资额度产生赎回资金不能实时到账\nD. 根据历史业绩，向客户宣传“XX宝”收益率高于3.50%大幅高于活期存款",
            "answer": "C",
            "explain": "本题考查基金销售人员行为规范。A选项不合规，货币市场基金是存在风险的，并不能确保本金安全，只是风险相对其他基金来说较低，A选项宣传“XX宝”的。C选项合规，基金销售人员应明确提示投资者注意投资基金的风险和限制条件，告知客户“XX宝”的限制条件是符合规定的。B、D选项不合规，不得混同、比较货币市场基金与银行存款及其他产品的投资收益，不得以宣传理财账户或者服务平"
        }, {
            "title": "根据《基金经营机构及其工作人员廉洁从业实施细则》规定，公司在( )时应向其传达廉洁从业要求，并要求其签署廉洁从业承诺书。",
            "questions": "I. 员工入职<br>II. 员工离职<br>III. 员工升职<br>IV. 员工调岗",
            "question": "A. I、II、III、IV\nB. I、III、IV\nC. I、II、III\nD. I、II、IV",
            "answer": "B",
            "explain": "本题考查廉洁从业的内控机制。根据《基金经营机构及其工作人员廉洁从业实施细则》第九条规定，基金经营机构应当加强廉洁文化建设，每年开展覆盖全体工作人员的廉洁从业教育。"
        },
        {
            "title": "某公募基金拟于2021年7月11日(周四)公开发售，该公募基金的基金管理公司最晚应于( )在指定网站上公布基金招募说明书、基金合同、基金托管协议、基金份额发售公告、基金产品资料概要。",
            "question": "A. 2021年7月9日\nB. 2021年7月10日\nC. 2021年7月7日\nD. 2021年7月8日",
            "answer": "D",
            "explain": "本题考查公开募集基金的发售。基金管理人应当在基金份额发售的3日前公布招募说明书、基金合同及其他有关文件。2021年7月11日的3日前，即最晚于2021年7月8日这一天公布。"
        },
        {
            "title": "货币市场基金需要定期披露( )。",
            "questions": "I. 基金份额净值<br>II. 基金资产净值<br>III. 每万份基金收益<br>IV. 最近7日年化收益率",
            "question": "A. II、III、IV\nB. I、II\nC. I、II、IV\nD. III、IV",
            "answer": "D",
            "explain": "本题考查货币市场基金信息披露的特点。货币市场基金不像其他类型基金那样定期披露份额净值，而是需要披露收益公告，包括每万份基金收益和最近7日年化收益率。"
        },
        {
            "title": "封闭式基金募集期限届满时，募集的基金份额需达到标准规模的( )以上才能达到基金合同生效的条件。",
            "question": "A. 60%\nB. 70%\nC. 80%\nD. 90%",
            "answer": "C",
            "explain": "本题考查基金合约的生效。封闭式基金募集成功条件为基金募集期限届满，封闭式基金需满足募集的基金份额总额达到核准规模的80%以上，并且基金份额持有人人数达到200人以上。"
        },
        {
            "title": "(材料题)B证券公司前员工李某，多次利用自己掌握的计算机知识，破解密码登入A基金公司的信息系统，非法侵入高管账号，获取员工通讯录、客户信息和公募基金电合持仓部分信息。经监管部门核查，发现如下事实:\n(1)关于信息技术内部控制的作用，以下说法错误的是( )。",
            "question": "A. 加强重要信息系统密码管控，增加检查频次\nB. 提高信息安全，防范数据的不当外泄\nC. 通过信息技术手段适当减少内部控制覆盖的范围，以提高内部控制的有效性\nD. 通过信息系统流程固化，促进业务开展的合法合规性",
            "answer": "C",
            "explain": "本题考查基金管理人的内部控制。C项错误，提高内部控制的有效性应当增加内部控制覆盖的范围而不是减少。"
        },
        {
            "title": "(材料题)B证券公司前员工李某，多次利用自己掌握的计算机知识，破解密码登入A基金公司的信息系统，非法侵入高管账号，获取员工通讯录、客户信息和公募基金组合持仓部分信息。经监管部门核查，发现如下事实:\n(2) 以下不属于A基金公司信息技术事前防御性控制缺陷的问题的是( )。",
            "question": "A. 弱密码设计\nB. 密码强制更新频率过低\nC. 防攻击防渗透测试的演练情景设计不够全面\nD. 向监管部门报告的时间跟后",
            "answer": "D",
            "explain": "本题考查信息技术系统控制。D项属于事后处置措施不完善，而不是“信息技术事前防御性控制缺陷”。"
        },
        {
            "title": "(材料题)B证券公司前员工李某，多次利用自己掌握的计算机知识，破解密码登入A基金公司的信息系统，非法侵入高管账号，获取员工通讯录、客户信息和公募基金组合持仓部分信息。经监管部门核查，发现如下事实:\n(3) 关于李某行为的性质，以下表述错误的是（　　）。",
            "question": "A. 非法侵入计算机系统\nB. 信息披露违规\nC. 利用未公开信息交易\nD. 窃取并买卖个人信息侵犯隐私权",
            "answer": "B",
            "explain": "本题考查信息披露控制。A选项表述正确，李某破解密码登入A基金公司的信息系统非法侵入高管账号，获取员工通讯录、客户信息和公募基金组合持仓部分信息。B选项表述错误，李某的行为不符合信息披露违规。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/flfg-6.js